// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("core.ruffle." + {"482":"7575dee8e8fbc7a7260d","655":"c4411aa29f0720127d83"}[chunkId] + ".js");